// test2253
(2253 && 0);
